import Vue from 'vue'
import VueI18n from 'vue-i18n'

Vue.use(VueI18n)

const messagesSite = require(/* webpackChunkName: "resource" */ `@/resources/website.json`)
const messagesCms = require(/* webpackChunkName: "resource" */ `@/resources/cms.json`)

export const i18n = new VueI18n({
  locale: 'nl-NL',
  fallbackLocale: 'nl-NL',
  messages: messagesSite
})

export var _Vue

export const resx = {
  install (Vue) {
    if (this.installed && _Vue === Vue) return
    this.installed = true

    _Vue = Vue

    var cache = {}

    Object.defineProperty(Vue.prototype, '$resx', {
      get () {
        return function (key, data, lang) {
          var self = this
          lang = lang || self.$store.state.adminLanguage
          if (!cache.hasOwnProperty(lang)) { cache[lang] = {} }
          if (cache[lang].hasOwnProperty(key)) { return cache[lang][key] }
          var keys = key.split('.')
          var message = messagesCms[lang]
          if (message) {
            for (var i = 0; i < keys.length; i++) {
              var k = keys[i]

              if (message.hasOwnProperty(k)) {
                message = message[k]
              } else {
                message = false
                break
              }
            }
            // if (message) {
            if (Object.prototype.toString.call(data) === '[object Array]') {
              message = message.replace(/{(\d+)}/g, function (match, number) {
                return typeof data[number] !== 'undefined'
                  ? data[number]
                  : match
              })
            } else if (typeof data === 'object' && data !== null) {
              message = message.replace(/\{ *([\w_-]+) *\}/g, function (str, k) {
                var value = data[k]
                if (value === undefined) {
                  throw new Error('No value provided for variable ' + str)
                } else if (typeof value === 'function') {
                  value = value(data)
                }
                return value
              })
            }
            if (message === false) {
              return '#' + key.toUpperCase()
            }
            cache[lang][key] = message
            return (message === false ? '#' + key.toUpperCase() : message)
          }
          return key
        }
      }
    })
  }
}
